(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bherdy-flash-sale-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bherdy-flash-banner').forEach(function (root) {
    var end = new Date(root.dataset.end).getTime();
    var numEls = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };
    var timer = null;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        root.classList.add('bherdy-flash-banner--ended');
        if (timer) clearInterval(timer);
        return;
      }
      numEls.days.textContent = pad(Math.floor(diff / 86400000));
      numEls.hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      numEls.minutes.textContent = pad(Math.floor((diff % 3600000) / 60000));
      numEls.seconds.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    if (!isNaN(end)) {
      tick();
      timer = setInterval(tick, 1000);
    }

    var toggle = root.querySelector('.bherdy-flash-banner__toggle');
    var emailRow = root.querySelector('.bherdy-flash-banner__email-row');
    if (toggle && emailRow) {
      toggle.addEventListener('click', function () {
        var willShow = emailRow.hasAttribute('hidden');
        if (willShow) {
          emailRow.removeAttribute('hidden');
        } else {
          emailRow.setAttribute('hidden', '');
        }
        toggle.setAttribute('aria-expanded', String(willShow));
        if (willShow) {
          var input = emailRow.querySelector('input[type="email"]');
          if (input) input.focus();
        }
      });
    }

    var reveal = root.querySelector('.bherdy-flash-reveal');
    if (reveal) {
      var closeReveal = function () {
        reveal.setAttribute('hidden', '');
      };
      var closeBtn = reveal.querySelector('[data-flash-reveal-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeReveal);
      reveal.addEventListener('click', function (e) {
        if (e.target === reveal) closeReveal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !reveal.hasAttribute('hidden')) closeReveal();
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
